import React, { useContext, useEffect, useState } from "react";
import { RatesContext } from "../providers/RatesProvider";
import { useParams, useLocation } from "react-router-dom";
import { ratesRef } from "../firebase";
import Footer from "./Footer";
import "../css/settingsForm.scss";
import { doc, updateDoc } from "firebase/firestore";

const RatesForm = () => {
  const location = useLocation();
  const ratesData = useContext(RatesContext);
  const [rateData, setRateData] = useState(location.state.rate);
  const params = useParams();

  useEffect(() => {
    const rate = ratesData.find((r) => r.uid === params.uid);
    setRateData(rate);
  }, [ratesData, params.uid]);

  const inputHandler = (e) => {
    let name = e.target.name;
    let value = e.target.value;

    if (name === "accessId") {
      value = Number(value);
      // console.log("value converted", value);
    }

    updateDoc(doc(ratesRef, params.uid), { [name]: value });
  };

  return (
    <div className="settingsFormPage">
      <Footer title={"Rates"} back={true}>
        {/* <button onClick={addJobDescription} className="adder">
          @
        </button> */}
      </Footer>
      <form className="settingsForm">
        <div className="formLine">
          <label htmlFor="name">Name</label>
          <input
            value={rateData?.name ?? ""}
            id="name"
            name="name"
            onChange={inputHandler}
            type="text"
          />
        </div>

        <div className="formLine">
          <label htmlFor="ratePerHour">Rate (£)</label>
          <input
            value={rateData?.ratePerHour ?? 0}
            id="ratePerHour"
            name="ratePerHour"
            onChange={inputHandler}
            className="arrowLess"
            type="number"
          />
        </div>
        {/* <label htmlFor="secondaryRate">
        <input id="secondaryRate" name="secondaryRate" type="text" />
      </label> */}
        <div className="formLine">
          <label htmlFor="description">Description</label>
          <input
            value={rateData?.description ?? ""}
            id="description"
            name="description"
            onChange={inputHandler}
            type="text"
          />
        </div>

        <div className="formLine">
          <label htmlFor="accessId">Access ID</label>
          <input
            value={rateData?.accessId ?? -1}
            id="accessId"
            name="accessId"
            onChange={inputHandler}
            className="arrowLess"
            type="number"
          />
        </div>
      </form>
    </div>
  );
};

export default RatesForm;
